import { NativeType } from '../enums';

type Func = (arg: any) => void;
type NoArgFunc = () => void;
interface Callback {
  resolve: Func,
  reject: NoArgFunc,
}
export interface CallbackData {
  callbackId: number;
  success: boolean;
  data: any;
}

export const callbacks: {[key: string]: Callback} = {};
const createCallback = (oldCallback: Func): Func => (data: CallbackData): void => {
  if (typeof oldCallback === 'function') {
    oldCallback(data);
  }
  const { callbackId } = data;
  const callback = callbacks[callbackId];
  if (callback) {
    callback.resolve(data);
    delete callbacks[callbackId];
  }
};

export const initCallback = (type: NativeType): void => {
  if (type === NativeType.APP) {
    (<any>window).callBack = createCallback((<any>window).callBack);
  } else if (type === NativeType.MINI_PROGRAM) {
    (<any>window).my.onMessage = createCallback((<any>window).my.onMessage);
  }
};

let id = 0;
export const pushCallback = (param: Callback): string => {
  const newId = `bridge_core_callback_${id}`;
  callbacks[newId] = {
    resolve: param.resolve,
    reject: param.reject,
  };
  id += 1;
  return newId;
};
